import { observer } from "mobx-react-lite";
import { useSingleton } from "../injection";
import { ConnectionStatusStore } from "./ConnectionStatusStore";
import styled from "@emotion/styled";

export const ConnectionStatus = observer(() => {
    const store = useSingleton(ConnectionStatusStore);

    return (
        <>
            {store.showOverlay && (
                <Overlay>
                    Disconnected from server.&nbsp;
                    {store.status === "connecting" &&
                        "Establishing connection..."}
                    {store.status === "disconnected" && (
                        <>
                            Retrying in {store.delaySeconds} second
                            {store.delaySeconds !== 1 && "s"}. (
                            <TryNow onClick={store.attemptConnectionNow}>
                                try now
                            </TryNow>
                            )
                        </>
                    )}
                    {store.status === "connected" && "Connected."}
                </Overlay>
            )}
        </>
    );
});

const Overlay = styled("div")(props => ({
    position: "absolute",
    left: 8,
    bottom: 8,
    zIndex: 999,
    display: "inline-block",
    minWidth: 375,
    padding: 8,
    backgroundColor: props.theme.error,
    color: props.theme.dangerForeground
}));

const TryNow = styled("span")({
    textDecoration: "underline",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "none"
    }
});
